import React from "react";
import { HubHookFormSelect } from "../../components";
// import { Chip, Stack, Typography } from "@mui/material";
import { PART_STATUSES } from "../../constants";
import { useFormContext } from "react-hook-form";
import { Chip, Stack, Typography } from "@mui/material";
import { HubHookFormSelectV2 } from "../../components/HubHookFormSelectV2";

const sxChip = {
  fontSize: "10px !important",
  fontWeight: 400,
  height: 20,
  span: { padding: 0 },
  padding: "5px",
};

const OrderRender = ({ label, status }) => {
  const partStatus = PART_STATUSES.find((p) => p.label === status);
  return (
    <Stack direction="row" gap="10px" alignItems="center">
      <Typography
        sx={{
          fontSize: "12px !important",
          fontWeight: 500,
        }}
      >
        {label}
      </Typography>
      <Chip sx={sxChip} {...partStatus} variant="colorTag" />
    </Stack>
  );
};

const OrderPartSelect = ({ prefix, options, ...rest }) => {
  const { watch } = useFormContext();
  const locationId = watch(prefix + "locationId");

  const MAPPED = options?.map((o) => {
    const status =
      o?.statuses?.find((p) => p.locationId === locationId)?.status || 2;
    return {
      id: o.id,
      label: o.label,
      status: PART_STATUSES.find((p) => p.id === status).label,
    };
  });

  return (
    <HubHookFormSelectV2
      options={MAPPED}
      RenderComponent={(opt) => <OrderRender {...opt} />}
      renderValue={(value) => {
        const opt = MAPPED?.find(({ id }) => id === value);
        return <OrderRender {...opt} />;
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          padding: "10px 30px 10px 15px !important",
          "& .MuiSvgIcon-root": {
            width: "15px",
            height: "15px",
          },
        },
      }}
      {...rest}
    />
  );
};

export default OrderPartSelect;
